import { makeHook } from "../../utils/makeSingleArgHook";
import getClientChecklistV2, { clientChecklistUrlV2, } from "../requests/getClientChecklistV2";
export const clientChecklistKeyMakerV2 = (clientId) => [
    clientId,
    clientChecklistUrlV2(clientId),
];
const useClientChecklistV2 = makeHook(getClientChecklistV2, clientChecklistKeyMakerV2);
export default useClientChecklistV2;
//# sourceMappingURL=useClientChecklistV2.js.map